import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import location from '@/assets/others/location.png';
import Checkbox from 'ant-design-vue/es/vc-checkbox/src/Checkbox'; // import xiaofangche from '@/assets/others/xiaofangche.gltf'

export default {
  name: 'earth1',
  components: {
    Checkbox: Checkbox
  },
  data: function data() {
    return {
      roamLine: null,
      roamLineData: {},
      eventTarget: new mars3d.BaseClass(),
      formState: {
        minHeight: '',
        maxHeight: '',
        speed: 10
      },
      formState1: {
        enabledWadi: true,
        enabledWaiqiege: false,
        enabledShendu: true,
        txtHeight: 30
      },
      terrainPlanClip: null,
      map: null,
      graphic: null,
      dynamicRiver: null,
      floodByGraphic: null,
      drawPotions: null,
      mapOptions: {
        scene: {
          //默认视角参数
          // center: { lat:34.3227, lng: 108.5525, alt: 100000, heading: 0, pitch: -25},//初始动画
          // center: { lat: 34.3227, lng: 108.5525, alt: 10000000, heading: 0, pitch: -90 },//远距离地球
          // center: { 'lat': 34.216894, 'lng': 108.959834, 'alt': 591, 'heading': 4, 'pitch': -37 },//3D模型
          // center: { 'lat': 31.659116, 'lng': 117.077158, 'alt': 24.6, 'heading': 0, 'pitch': -37 },//视频融合
          // center: { lat: 31.840043, lng: 117.21586, alt: 554, heading: 360, pitch: -59 },//开挖分析
          center: {
            lat: 31.833959,
            lng: 117.220356,
            alt: 554,
            heading: 0,
            pitch: -59
          },
          //人漫游
          shadows: false,
          //是否启用日照阴影
          removeDblClick: true,
          //是否移除Cesium默认的双击事件
          //以下是Cesium.Viewer所支持的options【控件相关的写在另外的control属性中】
          sceneMode: 3,
          //3等价于Cesium.SceneMode.SCENE3D,
          //以下是Cesium.Scene对象相关参数
          showSun: true,
          //是否显示太阳
          showMoon: true,
          //是否显示月亮
          showSkyBox: true,
          //是否显示天空盒
          showSkyAtmosphere: true,
          //是否显示地球大气层外光圈
          fog: true,
          //是否启用雾化效果
          fxaa: true,
          //是否启用抗锯齿
          //以下是Cesium.Globe对象相关参数
          globe: {
            depthTestAgainstTerrain: true,
            //是否启用深度监测
            baseColor: '#546a53',
            //地球默认背景色
            showGroundAtmosphere: true,
            //是否在地球上绘制的地面大气
            enableLighting: false //是否显示昼夜区域

          },
          //以下是Cesium.ScreenSpaceCameraController对象相关参数
          cameraController: {
            zoomFactor: 3.0,
            //鼠标滚轮放大的步长参数
            minimumZoomDistance: 1,
            //地球放大的最小值（以米为单位）
            maximumZoomDistance: 50000000,
            //地球缩小的最大值（以米为单位）
            enableRotate: true,
            //2D和3D视图下，是否允许用户旋转相机
            enableTranslate: true,
            //2D和哥伦布视图下，是否允许用户平移地图
            enableTilt: true,
            // 3D和哥伦布视图下，是否允许用户倾斜相机
            enableZoom: true,
            // 是否允许 用户放大和缩小视图
            enableCollisionDetection: true //是否允许 地形相机的碰撞检测

          }
        },
        control: {
          compass: {
            top: '60px',
            left: '10px'
          },
          //导航球
          distanceLegend: {
            left: '100px',
            bottom: '2px'
          },
          //比例尺
          locationBar: {
            fps: true,
            template: '<div>经度:{lng}</div><div>纬度:{lat}</div> <div>海拔：{alt}米</div> <div>层级：{level}</div><div>方向：{heading}度</div> <div>俯仰角：{pitch}度</div><div>视高：{cameraHeight}米</div>'
          },
          //鼠标经纬度等信息状态栏
          mouseDownView: true,
          //鼠标旋转、放大时的按键效果美化图标
          baseLayerPicker: true,
          //basemaps底图切换按钮
          homeButton: true,
          //视角复位按钮
          sceneModePicker: true,
          //二三维切换按钮
          navigationHelpButton: true,
          //帮助按钮
          fullscreenButton: true //全屏按钮

        },
        // 地形
        terrain: {
          url: 'http://data.mars3d.cn/terrain',
          show: true
        },
        // 图层
        basemaps: [{
          name: '高德卫星',
          // icon: '//mars3d.cn/img/basemaps/gaode_img.png',
          type: 'gaode',
          layer: 'img_d',
          key: ['9ae78c51a0a28f06444d541148496e36'],
          show: true
        }],
        // // 三维模型
        layers: [{
          'name': '模型名称',
          'type': '3dtiles',
          'url': 'http://data.mars3d.cn/3dtiles/qx-dyt/tileset.json',
          'maximumScreenSpaceError': 1,
          'maximumMemoryUsage': 1024,
          'position': {
            'alt': -30
          },
          'center': {
            'lat': 34.216894,
            'lng': 108.959834,
            'alt': 591,
            'heading': 4,
            'pitch': -37
          },
          'show': true
        }]
      }
    };
  },
  destroyed: function destroyed() {
    this.map.destroy();
  },
  mounted: function mounted() {
    this.initMap();
  },
  watch: {
    'formState1.enabledWadi': function formState1EnabledWadi(val) {
      this.terrainPlanClip.enabled = val;
    },
    'formState1.enabledWaiqiege': function formState1EnabledWaiqiege(val) {
      this.terrainPlanClip.clipOutSide = val;
    },
    'formState1.enabledShendu': function formState1EnabledShendu(val) {
      this.terrainPlanClip.depthTestAgainstTerrain = val;
    },
    'formState1.txtHeight': function formState1TxtHeight(val) {
      this.terrainPlanClip.diffHeight = val;
    }
  },
  methods: {
    initMap: function initMap() {
      this.map = new mars3d.Map('mars3dContainer', this.mapOptions); // 放大缩小按钮

      var zoom = new mars3d.control.Zoom({
        insertIndex: 1,
        // 插入的位置顺序
        zoomInIcon: '//mars3d.cn/img/icon/zoom-in.svg',
        zoomOutIcon: '//mars3d.cn/img/icon/zoom-out.svg'
      });
      this.map.addControl(zoom); // this.startAnimation()
      // 手动设置视角飞行轨迹组
      // this.map.setCameraViewList([
      //   {
      //     lat: 34.3227,
      //     lng: 108.5525,
      //     alt: 17036414
      //   }, {
      //     lat: 34.3227,
      //     lng: 108.5525,
      //     alt: 5000000
      //   }
      // ], {
      //   duration: 3,
      //   complete: () => {
      //     // 执行完毕回调
      //   }
      // })
      //创建矢量数据图层

      this.graphic = new mars3d.layer.GraphicLayer();
      this.map.addLayer(this.graphic); // 加载石化工厂模型
      // const tiles3dLayer = new mars3d.layer.TilesetLayer({
      //   name: "石化工厂",
      //   url: "http://data.mars3d.cn/3dtiles/max-shihua/tileset.json",
      //   position: { lng: 117.077158, lat: 31.659116, alt: 50 },
      //   maximumScreenSpaceError: 1,
      //   maximumMemoryUsage: 1024,
      //   popup: "all"
      // })
      // this.map.addLayer(tiles3dLayer)
      // this.createDiv([108.5525, 30.3227],'Graphic',{
      //   html: '<div style="font-size: 20px;color: #00ff80;padding: 5px 10px;background-color: #2eabff;border-radius: 10px">我是矢量DIV容器</div>'
      // })
      // this.createDiv([108.5525, 30.3227],'LightPoint',{
      //   color: '#00ff80'
      // })
      // this.createDiv([108.5525, 30.3227],'UpLabel',{
      //   color: '#00ff80',
      //   text:'我是UpLabel类文本',
      //   font_size:20,
      //   circleSize:9
      // })
      // this.createDiv([108.5525, 30.3227],'BoderLabel',{
      //   color: '#00ff80',
      //   text:'我是BoderLabel类文本',
      //   font_size:20,
      //   width:200,
      //   height:100,
      //   boderColor:'yellow'
      // })
      // this.createEntity([107.5525, 34.3227],'Label',{
      //   text:'我是Label类Entity矢量对象\n我还可以换行',
      //   color:'#0000ff',
      //   opacity:0.5,
      //   font_size:20,
      //   background:true,
      //   backgroundColor:'#ffffff'
      // })
      // this.createEntity([109.5525, 38.3227],'Point',{
      //   pixelSize:20,
      //   color:'#00ffff',
      //   label:{
      //     text:'我是Point类Entity矢量对象的文本说明,我往下偏移了20',
      //     color:'#00ffff',
      //     hasPixelOffset:true,//是否开启偏移
      //     pixelOffsetY:20//纵向偏移量
      //   }
      // })
      // this.createEntity([109.5525, 40.3227],'Billboard',{
      //   image:location,
      //   scale:0.2,
      //   label:{
      //     text:'我是Billboard类Entity矢量对象的文本说明,我往下偏移了40',
      //     color:'#ff0000',
      //     hasPixelOffset:true,//是否开启偏移
      //     pixelOffsetY:40//纵向偏移量
      //   }
      // })
      // this.createEntity([104.5525, 29.3227],'Model',{
      //   url:"//data.mars3d.cn/gltf/mars/qiche.gltf",
      //   scale:500,
      //   label:{
      //     text:'我是Model类Entity矢量对象的文本说明,我往下偏移了30',
      //     color:'#00ff00',
      //     hasPixelOffset:true,//是否开启偏移
      //     pixelOffsetY:40//纵向偏移量
      //   }
      // })
      // this.createLineEntity()
      // this.createPolylineVolumeVolumeEntity()
      // this.createPrimitive([104.5525, 29.3227],'Label',{
      //   text:'我是Label类Entity矢量对象\n我还可以换行',
      //   color:'#0000ff',
      //   opacity:0.5,
      //   font_size:20,
      //   background:true,
      //   backgroundColor:'#ffffff'
      // })
      // this.createWallPrimitive()
      // this.createDiffuseWallPrimitive()
      // this.createPolylineCombinePrimitive()
      // this.createScrollWallPrimitive()
      // this.createModelDynamicPosition()
      // this.createDynamicRiver()
      // this.createBoxProperty()
      // this.createGeoWallPrimitive()
      // this.createVideo([117.077158, 31.659116])
      // this.createFlood()
      // this.createPlanes()
      // this.wallData=[
      //   {
      //       start:[117.077158, 31.659116],
      //       end:[117.277158, 31.659116],
      //       color:'#ff8477',
      //       value:8
      //   },
      //   {
      //     start:[117.277158, 31.659116],
      //     end:[117.477158, 31.659116],
      //     color:'#4a87ff',
      //     value:5
      //   },
      //   {
      //     start:[117.477158, 31.659116],
      //     end:[117.677158, 31.659116],
      //     color:'#ff7ffc',
      //     value:7
      //   },
      //   {
      //     start:[117.677158, 31.659116],
      //     end:[117.877158, 31.659116],
      //     color:'#ffc03c',
      //     value:6
      //   },
      //   {
      //     start:[117.877158, 31.659116],
      //     end:[118.077158, 31.659116],
      //     color:'#21ff74',
      //     value:3
      //   }
      // ]
      // this.wallData.forEach((item,i)=>{
      //   this.createWallChart(item.start,item.end,item.color,i+1,item.value)
      // })
      // this.createPeopleFly()
    },
    // 设置开场动画
    startAnimation: function startAnimation() {
      // 飞行到默认视角
      this.map.flyHome({
        duration: 0
      }); // 开场动画

      this.map.openFlyAnimation({
        // duration1:4,
        // easingFunction1: Cesium.EasingFunction.QUINTIC_IN_OUT,
        callback: function callback() {// 动画播放完成后回调
        }
      });
    },
    // 创建div 矢量对象
    createDiv: function createDiv(position, type, style, name) {
      var divGraphic = new mars3d.graphic['Div' + type]({
        position: new mars3d.LatLngPoint(position[0], position[1], 1000),
        style: style,
        popup: '<div style="color: #2eabff;height: 100px"><div>我是自定义html</div>' + "<img style=\"width: 50px;height: auto\" src=".concat(location, ">") + '</div>' // tooltip:'<div style="color: #2eabff;height: 100px"><div>我是自定义html</div>' +
        //   `<img style="width: 50px;height: auto" src=${location}>` +
        //   '</div>',

      });
      this.graphic.addGraphic(divGraphic); // divGraphic.on(mars3d.EventType.click,(event)=> {
      //   console.log('单击了矢量数据对象', event)
      //
      // })
      // divGraphic.bindTooltip("我是layer上绑定的Tooltip")
      // divGraphic.bindPopup("我是layer上绑定的Popup")

      divGraphic.bindContextMenu([{
        text: '删除对象',
        iconCls: 'fa fa-trash-o',
        callback: function callback(e) {
          var graphic = e.graphic;

          if (graphic) {
            graphic.remove();
          }
        }
      }]);
    },
    // 创建Entity 矢量对象
    createEntity: function createEntity(position, type, style) {
      var entity = new mars3d.graphic[type + 'Entity']({
        position: new mars3d.LatLngPoint(position[0], position[1], 1000),
        style: style
      });
      this.graphic.addGraphic(entity);
    },
    // 创建Entity-线
    createLineEntity: function createLineEntity() {
      var entity = new mars3d.graphic.PolylineEntity({
        positions: [new mars3d.LatLngPoint(104.5525, 29.3227, 1000), new mars3d.LatLngPoint(105.5525, 28.3227, 1000)],
        style: {
          width: 10,
          color: '#ffffff',
          // closure: true,//是否闭合
          // material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.PolylineArrow, {
          //   color: Cesium.Color.YELLOW
          // }),//箭头线
          // material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.PolylineDash, {
          //   color: Cesium.Color.CYAN,
          //   dashLength: 8.0
          // }),//虚线
          // material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.PolylineDash, {
          //   color: Cesium.Color.BLUE,
          //   gapColor: Cesium.Color.YELLOW,
          //   dashPattern: parseInt("1111000000", 2)
          // }),//虚线 ，双色间隔
          // material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.LineFlow, {
          //   color: "#66bd63",
          //   repeat: new Cesium.Cartesian2(2.0, 1.0),
          //   image: "//mars3d.cn/img/textures/line.png",
          //   speed: 25
          // }),// 动画线材质
          // material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.LineFlow, {
          //   color: "rgba(89,249,255,0.8)",
          //   image: "//mars3d.cn/img/textures/LineDataTrans.png",
          //   speed: 8
          // }),
          // material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.LineFlow, {
          //   color: Cesium.Color.CHARTREUSE,
          //   image: "//mars3d.cn/img/textures/lineClr.png",
          //   speed: 25
          // }),
          // material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.LineFlow, {
          //   color: "#a6d96a",
          //   repeat: new Cesium.Cartesian2(4.0, 1.0),
          //   image: "//mars3d.cn/img/textures/arrow_1.png",
          //   speed: 20
          // }),
          // material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.LineFlow, {
          //   color: "#00ff00",
          //   image: "//mars3d.cn/img/textures/LinkPulse.png",
          //   speed: 3
          // }),
          // material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.LineFlowColor, {
          //   color: "#00ffff",
          //   speed: 10,
          //   percent: 0.15,
          //   alpha: 0.2
          // }),
          material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.LineFlow, {
            color: '#1a9850',
            image: '//mars3d.cn/img/textures/lineAarrow.png',
            speed: 20,
            repeat: new Cesium.Cartesian2(5, 1)
          }),
          //绿箭头
          label: {
            text: '我是Polyline类Entity矢量对象的文本说明',
            color: '#ffffff',
            hasPixelOffset: true,
            //是否开启偏移
            pixelOffsetY: 20 //纵向偏移量

          }
        }
      });
      this.graphic.addGraphic(entity);
    },
    // 创建Entity-管道
    createPolylineVolumeVolumeEntity: function createPolylineVolumeVolumeEntity() {
      var entity = new mars3d.graphic.PolylineVolumeEntity({
        positions: [new mars3d.LatLngPoint(100.5525, 25.3227, 1000), new mars3d.LatLngPoint(101.5525, 26.3227, 1000), new mars3d.LatLngPoint(103.5525, 26.3227, 1000), new mars3d.LatLngPoint(104.5525, 25.3227, 1000)],
        style: {
          radius: 1000,
          color: '#ffffff',
          shape: 'circle',
          label: {
            text: '我是PolylineVolume类Entity矢量对象的文本说明',
            color: 'yellow',
            hasPixelOffset: true,
            //是否开启偏移
            pixelOffsetY: 40 //纵向偏移量

          }
        }
      });
      this.graphic.addGraphic(entity);
    },
    // 创建Primitive  矢量对象
    createPrimitive: function createPrimitive(position, type, style) {
      var entity = new mars3d.graphic[type + 'Primitive']({
        position: new mars3d.LatLngPoint(position[0], position[1], 1000),
        style: style
      });
      this.graphic.addGraphic(entity);
    },
    // 创建Primitive-墙
    createWallPrimitive: function createWallPrimitive() {
      var entity = new mars3d.graphic.WallPrimitive({
        positions: [new mars3d.LatLngPoint(100.5525, 25.3227, 1000), new mars3d.LatLngPoint(101.5525, 26.3227, 1000), new mars3d.LatLngPoint(103.5525, 26.3227, 1000), new mars3d.LatLngPoint(104.5525, 25.3227, 1000)],
        style: {
          diffHeight: 80000,
          closure: true,
          color: 'yellow',
          opacity: 0.7,
          label: {
            text: '我是WallPrimitive类Entity矢量对象的文本说明',
            color: 'yellow',
            hasPixelOffset: true,
            //是否开启偏移
            pixelOffsetY: 40 //纵向偏移量

          }
        }
      });
      this.graphic.addGraphic(entity);
    },
    // 创建Primitive-大数据线集合(多条线)
    createPolylineCombinePrimitive: function createPolylineCombinePrimitive() {
      var entity = new mars3d.graphic.PolylineCombine({
        instances: [{
          positions: [new mars3d.LatLngPoint(100.5525, 25.3227, 1000), new mars3d.LatLngPoint(101.5525, 26.3227, 1000), new mars3d.LatLngPoint(103.5525, 26.3227, 1000), new mars3d.LatLngPoint(104.5525, 25.3227, 1000)],
          style: {
            color: 'yellow',
            opacity: 0.7
          }
        }, {
          positions: [new mars3d.LatLngPoint(98.5525, 25.3227, 1000), new mars3d.LatLngPoint(99.5525, 26.3227, 1000), new mars3d.LatLngPoint(100.5525, 26.3227, 1000), new mars3d.LatLngPoint(101.5525, 25.3227, 1000)],
          style: {
            color: 'yellow',
            opacity: 0.7
          }
        }],
        style: {
          width: 10,
          color: 'yellow',
          opacity: 0.7,
          label: {
            text: '我是PolylineCombine类Primitive矢量对象的文本说明',
            color: '#ff0000',
            hasPixelOffset: true,
            //是否开启偏移
            pixelOffsetY: 30 //纵向偏移量

          }
        }
      });
      this.graphic.addGraphic(entity);
    },
    // 创建Primitive-扩散墙
    createDiffuseWallPrimitive: function createDiffuseWallPrimitive() {
      var entity = new mars3d.graphic.DiffuseWall({
        positions: [new mars3d.LatLngPoint(100.5525, 25.3227, 1000), new mars3d.LatLngPoint(101.5525, 26.3227, 1000), new mars3d.LatLngPoint(103.5525, 26.3227, 1000), new mars3d.LatLngPoint(104.5525, 25.3227, 1000)],
        style: {
          diffHeight: 80000,
          speed: 10,
          color: 'yellow',
          opacity: 0.7
        }
      });
      this.graphic.addGraphic(entity);
    },
    // 创建Primitive-走马灯围墙
    createScrollWallPrimitive: function createScrollWallPrimitive() {
      var entity = new mars3d.graphic.ScrollWall({
        positions: [new mars3d.LatLngPoint(100.5525, 25.3227, 1000), new mars3d.LatLngPoint(101.5525, 26.3227, 1000), new mars3d.LatLngPoint(103.5525, 26.3227, 1000), new mars3d.LatLngPoint(104.5525, 25.3227, 1000)],
        style: {
          diffHeight: 8000,
          // 高度
          color: '#f2fa19',
          speed: 10,
          reverse: false,
          // 方向：true往上、false往下
          // 高亮时的样式（默认为鼠标移入，也可以指定type:'click'单击高亮），构造后也可以openHighlight、closeHighlight方法来手动调用
          highlight: {
            color: '#ff0000'
          }
        }
      });
      this.graphic.addGraphic(entity);
    },
    // 边界墙
    createGeoWallPrimitive: function createGeoWallPrimitive() {
      var _this = this;

      this.queryAreasData().then(function (data) {
        var arr = mars3d.Util.geoJsonToGraphics(data); // 解析geojson

        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          var graphic = new mars3d.graphic.WallEntity({
            positions: item.positions,
            style: {
              diffHeight: 5000,
              material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.LineFlow, {
                color: '#bdf700',
                image: 'http://mars3d.cn/img/textures/fence.png',
                repeat: new Cesium.Cartesian2(5, 1),
                axisY: true,
                // 方向，true时上下，false左右
                speed: 20
              })
            },
            attr: item.attr
          });

          _this.graphic.addGraphic(graphic);
        }
      });
    },
    // 边界墙绘制 - 数据获取
    queryAreasData: function queryAreasData() {
      return mars3d.Resource.fetchJson({
        url: '//data.mars3d.cn/file/geojson/areas/340100.json'
      });
    },
    // 车模型动态位置
    createModelDynamicPosition: function createModelDynamicPosition() {
      var entity = new mars3d.graphic.ModelEntity({
        style: {
          scale: 500,
          url: '//data.mars3d.cn/gltf/mars/qiche.gltf',
          // 高亮时的样式（默认为鼠标移入，也可以指定type:'click'单击高亮），构造后也可以openHighlight、closeHighlight方法来手动调用
          highlight: {
            type: mars3d.EventType.click,
            silhouette: true,
            silhouetteColor: '#ff0000',
            silhouetteSize: 4
          },
          label: {
            // 不需要文字时，去掉label配置即可
            text: '闽D123456',
            font_size: 16,
            color: '#ffffff',
            outline: true,
            outlineColor: '#000000',
            pixelOffsetY: -40
          }
        }
      });
      this.graphic.addGraphic(entity); // 定时更新动态位置（setInterval为演示）

      var jd = 104.5525;
      var wd = 29.3227;
      setInterval(function () {
        entity.addDynamicPosition(Cesium.Cartesian3.fromDegrees(jd, wd, 30));
        jd += 0.1;
      }, 1000);
    },
    // 动态河流
    createDynamicRiver: function createDynamicRiver() {
      var entity = new mars3d.graphic.DynamicRiver({
        positions: [[108.906607, 34.441582, 555.9], [108.899964, 34.438543, 467.3]],
        style: {
          image: '//mars3d.cn/img/textures/movingRiver.png',
          width: 30000,
          height: 100,
          speed: 10
        }
      });
      this.graphic.addGraphic(entity);
    },
    // 绘制河流
    drawLine: function drawLine(width, height, speed) {
      var _this2 = this;

      this.map.graphicLayer.startDraw({
        type: 'polyline',
        style: {
          color: '#55ff33',
          width: 3
        },
        success: function success(graphic) {
          var points = graphic.points;
          console.log(JSON.stringify(graphic.coordinates)); // 打印下边界

          graphic.remove(); // 删除绘制的线

          _this2.dynamicRiver = new mars3d.graphic.DynamicRiver({
            positions: points,
            style: {
              image: '//mars3d.cn/img/textures/movingRiver.png',
              width: width,
              height: height,
              speed: speed
            }
          });

          _this2.graphic.addGraphic(_this2.dynamicRiver);
        }
      }); // 可在图层绑定右键菜单,对所有加到这个图层的矢量数据都生效

      this.graphic.bindContextMenu([{
        text: '删除对象',
        iconCls: 'fa fa-trash-o',
        callback: function callback(e) {
          var primitive = e.graphic;

          if (primitive) {
            _this2.graphic.removeGraphic(primitive);
          }
        }
      }]);
    },
    // 绘制道路
    drawRoad: function drawRoad(width, height) {
      var _this3 = this;

      this.map.graphicLayer.startDraw({
        type: 'polyline',
        style: {
          color: '#55ff33',
          width: 3
        },
        success: function success(graphic) {
          var points = graphic.points;
          console.log(JSON.stringify(graphic.coordinates)); // 打印下边界

          graphic.remove(); // 删除绘制的线

          var road = new mars3d.graphic.Road({
            positions: points,
            style: {
              image: '//mars3d.cn/img/textures/road.jpg',
              width: width,
              height: height,
              opacity: 1
            }
          });

          _this3.graphic.addGraphic(road);
        }
      }); // 可在图层绑定右键菜单,对所有加到这个图层的矢量数据都生效

      this.graphic.bindContextMenu([{
        text: '删除对象',
        iconCls: 'fa fa-trash-o',
        callback: function callback(e) {
          var primitive = e.graphic;

          if (primitive) {
            _this3.graphic.removeGraphic(primitive);
          }
        }
      }]);
    },
    // 河流抬高
    addHeight: function addHeight() {
      if (!this.dynamicRiver) {
        return;
      }

      this.dynamicRiver.offsetHeight(50, 5); // 5秒内抬高50米
    },
    // 河流下降
    lowerHeight: function lowerHeight() {
      if (!this.dynamicRiver) {
        return;
      }

      this.dynamicRiver.offsetHeight(-50, 5); // 5秒内降低50米
    },
    // 创建盒子应用Property(颜色随时间渐变)
    createBoxProperty: function createBoxProperty() {
      // 创建盒子
      var marsBox = new mars3d.graphic.BoxEntity({
        position: [108.220164, 34.834887, 39.6],
        style: {
          dimensions: new Cesium.Cartesian3(400000.0, 300000.0, 100000.0),
          color: 'rgba(0,255,255,0.8)',
          outline: true
        }
      });
      var colorProperty = new Cesium.SampledProperty(Cesium.Color);
      colorProperty.addSample(Cesium.JulianDate.fromDate(new Date('2021-12-08 10:21:00')), new Cesium.Color(0, 0, 1));
      colorProperty.addSample(Cesium.JulianDate.fromDate(new Date('2021-12-08 10:21:20')), new Cesium.Color(1, 1, 0));
      marsBox.setStyle({
        material: new Cesium.ColorMaterialProperty(colorProperty)
      });
      this.graphic.addGraphic(marsBox);
    },
    // 视频融合应用
    createVideo: function createVideo(position) {
      var graphicImg = new mars3d.graphic.DivGraphic({
        position: position,
        style: {
          html: " <div class=\"mars3d-camera-content\">\n                    <img class=\"mars3d-camera-img\" src=\"//mars3d.cn/img/marker/camera.svg\" >\n                  </div>\n                  <div class=\"mars3d-camera-line\" ></div>\n                  <div class=\"mars3d-camera-point\"></div>\n                ",
          offsetX: -16,
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 100000)
        },
        popup: "<video src='http://data.mars3d.cn/file/video/lukou.mp4' controls autoplay style=\"width: 300px;\" ></video>",
        popupOptions: {
          offsetY: -170,
          // 显示Popup的偏移值，是DivGraphic本身的像素高度值
          template: "<div class=\"marsBlackPanel animation-spaceInDown\">\n                      <div class=\"marsBlackPanel-text\">{content}</div>\n                      <span class=\"mars3d-popup-close-button closeButton\" >\xD7</span>\n                    </div>",
          horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
          verticalOrigin: Cesium.VerticalOrigin.CENTER
        }
      });
      this.graphic.addGraphic(graphicImg);
    },
    // 淹没分析
    createFlood: function createFlood() {
      // 基于polygon矢量面抬高模拟，只支持单个区域
      this.floodByGraphic = new mars3d.thing.FloodByGraphic({
        // speed: speed,
        style: {
          color: '#007be6',
          opacity: 0.5,
          outline: false
        }
      });
      this.map.addThing(this.floodByGraphic);
    },
    // 淹没分析-清除
    clearDraw: function clearDraw() {
      this.drawPotions = null;
      this.map.graphicLayer.clear();
    },
    // 淹没分析-绘制矩形
    btnDrawExtent: function btnDrawExtent() {
      var _this4 = this;

      this.drawPotions = null;
      this.floodByGraphic.clear();
      this.map.graphicLayer.clear();
      this.map.graphicLayer.startDraw({
        type: 'rectangle',
        style: {
          color: '#007be6',
          opacity: 0.8,
          outline: false
        },
        success: function success(graphic) {
          // 绘制成功后回调
          var positions = graphic.getOutlinePositions(false); // 区域

          _this4.drawPotions = positions; // 求最大、最小高度值
          // this.showLoading()

          var result = mars3d.PolyUtil.getHeightRange(positions, _this4.map.scene);
          _this4.formState.minHeight = Math.ceil(result.minHeight);
          _this4.formState.maxHeight = Math.ceil(result.maxHeight); // hideLoading()
        }
      });
    },
    // 淹没分析-绘制多边形
    btnDraw: function btnDraw() {
      var _this5 = this;

      this.drawPotions = null;
      this.floodByGraphic.clear();
      this.map.graphicLayer.clear();
      this.map.graphicLayer.startDraw({
        type: 'polygon',
        style: {
          color: '#007be6',
          opacity: 0.5,
          outline: false
        },
        success: function success(graphic) {
          var positions = graphic.positionsShow;
          _this5.drawPotions = positions; // 求最大、最小高度值
          // showLoading()

          var result = mars3d.PolyUtil.getHeightRange(positions, _this5.map.scene);
          _this5.formState.minHeight = Math.ceil(result.minHeight);
          _this5.formState.maxHeight = Math.ceil(result.maxHeight); // hideLoading()
        }
      });
    },
    // 开始淹没分析
    begin: function begin(data) {
      if (this.drawPotions == null) {
        return;
      }

      this.map.graphicLayer.clear();
      this.floodByGraphic.positions = this.drawPotions;
      var minValue = Number(data.minHeight);
      var maxValue = Number(data.maxHeight);
      var speed = Number(data.speed);
      console.log(minValue, maxValue, speed);
      this.floodByGraphic.setOptions({
        minHeight: minValue,
        maxHeight: maxValue,
        speed: speed
      });
      this.floodByGraphic.start();
    },
    // 开挖分析
    createPlanes: function createPlanes() {
      // 管网数据：3dtiles
      var tilesetLayer = new mars3d.layer.TilesetLayer({
        name: '地下管网',
        url: '//data.mars3d.cn/3dtiles/max-piping/tileset.json',
        position: {
          lng: 117.215457,
          lat: 31.843363,
          alt: -3.6
        },
        rotation: {
          z: 336.7
        },
        maximumScreenSpaceError: 2,
        maximumMemoryUsage: 1024,
        highlight: {
          type: 'click',
          color: '#00FFFF'
        },
        popup: 'all',
        center: {
          lat: 31.840525,
          lng: 117.217024,
          alt: 495.12,
          heading: 0,
          pitch: -59.3,
          roll: 0
        }
      });
      this.map.addLayer(tilesetLayer);
      this.terrainPlanClip = new mars3d.thing.TerrainPlanClip({
        // positions: [
        //   [117.214491, 31.841736, 42.83],
        //   [117.21764, 31.841736, 42.83],
        //   [117.21764, 31.843807, 42.83],
        //   [117.214491, 31.843807, 42.83]
        // ],
        diffHeight: 30,
        // 井的深度
        image: 'http://mars3d.cn/img/textures/excavate_side_min.jpg',
        // 边界墙材质
        imageBottom: 'http://mars3d.cn/img/textures/excavate_bottom_min.jpg',
        // 底部区域材质
        splitNum: 50 // 井边界插值数

      });
      this.map.addThing(this.terrainPlanClip);
    },
    // 开挖分析-绘制矩形
    btnDrawExtent1: function btnDrawExtent1() {
      var _this6 = this;

      this.terrainPlanClip.clear(); // 清除挖地区域

      this.map.graphicLayer.startDraw({
        type: 'rectangle',
        style: {
          color: '#007be6',
          opacity: 0.8,
          outline: false
        },
        success: function success(graphic) {
          // 绘制成功后回调
          var positions = graphic.getOutlinePositions(false);

          _this6.map.graphicLayer.clear();

          console.log(JSON.stringify(mars3d.PointTrans.cartesians2lonlats(positions))); // 打印下边界
          // 挖地区域

          _this6.terrainPlanClip.positions = positions;
        }
      });
    },
    // 开挖分析-绘制多边形
    btnDraw1: function btnDraw1() {
      var _this7 = this;

      this.terrainPlanClip.clear(); // 清除挖地区域

      this.map.graphicLayer.startDraw({
        type: 'polygon',
        style: {
          color: '#007be6',
          opacity: 0.5
        },
        success: function success(graphic) {
          // 绘制成功后回调
          var positions = graphic.positionsShow;

          _this7.map.graphicLayer.clear();

          console.log(JSON.stringify(mars3d.PointTrans.cartesians2lonlats(positions))); // 打印下边界
          // 挖地区域

          _this7.terrainPlanClip.positions = positions;
        }
      });
    },
    // 开挖分析-清除
    removeAll: function removeAll() {
      this.terrainPlanClip.clear(); // 清除挖地区域
    },
    // 创建图表墙
    createWallChart: function createWallChart(start, end, color, i, value) {
      var entity = new mars3d.graphic.WallEntity({
        positions: [new mars3d.LatLngPoint(start[0], start[1], 1000), new mars3d.LatLngPoint(end[0], end[1], 1000)],
        style: {
          diffHeight: value * 10000,
          material: mars3d.MaterialUtil.createMaterialProperty(mars3d.MaterialType.LineFlow, {
            color: color,
            image: 'http://mars3d.cn/img/textures/fence.png',
            repeat: new Cesium.Cartesian2(5, 1),
            axisY: true,
            // 方向，true时上下，false左右
            speed: 20
          }),
          label: {
            text: value + '',
            color: '#ffffff',
            hasPixelOffset: true,
            //是否开启偏移
            pixelOffsetZ: 200 //纵向偏移量

          }
        }
      });
      this.graphic.addGraphic(entity);
    },
    // 行人漫游
    createPeopleFly: function createPeopleFly() {
      var _this8 = this;

      // 该数据可以从 基础项目 飞行漫游功能界面操作后单个路线的 保存JSON
      var flydata = {
        name: '步行路线',
        speed: 40,
        positions: [[117.220356, 31.833959, 43.67], [117.220361, 31.835111, 44.36], [117.213242, 31.835863, 42.31], [117.211926, 31.835738, 42.14], [117.183103, 31.833906, 47.17], [117.183136, 31.833586, 47.39], [117.183968, 31.833637, 47.05], [117.184038, 31.833134, 47.39], [117.184364, 31.833142, 47.26], [117.184519, 31.833375, 47.04]],
        model: {
          show: true,
          url: '//data.mars3d.cn/gltf/mars/man/walk.gltf',
          scale: 5,
          minimumPixelSize: 50
        },
        shadow: [{
          type: 'circle',
          radius: 10,
          color: '#ffff00',
          opacity: 0.3,
          materialType: mars3d.MaterialType.CircleWave,
          speed: 10,
          count: 3,
          gradient: 0.1,
          show: true
        }],
        camera: {
          type: 'gs',
          radius: 300
        },
        clockRange: Cesium.ClockRange.CLAMPED,
        // CLAMPED到达终点后停止
        pauseTime: 0.5
      };
      this.roamLine = new mars3d.graphic.RoamLine(flydata);
      this.graphic.addGraphic(this.roamLine);
      this.roamLine.on(mars3d.EventType.endItem, function (event) {
        console.log('已漫游过点：' + event.index, event);
      });
      this.roamLine.on(mars3d.EventType.end, function (event) {
        console.log('漫游结束', event);
      });
      this.roamLine.on(mars3d.EventType.change, function (event) {
        // 面板显示相关信息
        _this8.showRealTimeInfo(event, _this8.roamLine.alltimes); // 漫游组件


        _this8.eventTarget.fire('roamLineChange', _this8.roamLineData);
      });
      this.roamLine.bindPopup(function () {
        var html = "<div id=\"popupContent\"  class=\"marsBlackPanel animation-spaceInDown\">\n          <div class=\"marsBlackPanel-text\">\n            <div style=\"width: 200px;text-align:left;\">\n              <div>\u603B \u8DDD \u79BB\uFF1A<span id=\"lblAllLen\"> </span></div>\n              <div>\u603B \u65F6 \u95F4\uFF1A<span id=\"lblAllTime\"> </span></div>\n              <div>\u5F00\u59CB\u65F6\u95F4\uFF1A<span id=\"lblStartTime\"> </span></div>\n              <div>\u5269\u4F59\u65F6\u95F4\uFF1A<span id=\"lblRemainTime\"> </span></div>\n              <div>\u5269\u4F59\u8DDD\u79BB\uFF1A<span id=\"lblRemainLen\"> </span></div>\n            </div>\n          </div>\n          <span class=\"mars3d-popup-close-button closeButton\" >\xD7</span>\n         </div>";
        return html;
      }, {
        offsetY: -40,
        template: false
      }); // 刷新局部DOM,不影响popup面板的其他控件操作

      this.roamLine.on(mars3d.EventType.postRender, function (event) {
        var container = event.container; // popup对应的DOM

        var params = this.roamLine ? this.roamLine.info : null;

        if (!params) {
          return;
        }

        var lblAllLen = container.querySelector('#lblAllLen');

        if (lblAllLen) {
          lblAllLen.innerHTML = mars3d.MeasureUtil.formatDistance(this.roamLine.alllen);
        }

        var lblAllTime = container.querySelector('#lblAllTime');

        if (lblAllTime) {
          lblAllTime.innerHTML = this.formatTime(this.roamLine.alltimes / map.clock.multiplier);
        }

        var lblStartTime = container.querySelector('#lblStartTime');

        if (lblStartTime) {
          lblStartTime.innerHTML = mars3d.Util.formatDate(Cesium.JulianDate.toDate(this.roamLine.startTime), 'yyyy-M-d HH:mm:ss');
        }

        var lblRemainTime = container.querySelector('#lblRemainTime');

        if (lblRemainTime) {
          lblRemainTime.innerHTML = this.formatTime((this.roamLine.alltimes - params.time) / map.clock.multiplier);
        }

        var lblRemainLen = container.querySelector('#lblRemainLen');

        if (lblRemainLen) {
          lblRemainLen.innerHTML = mars3d.MeasureUtil.formatDistance(this.roamLine.alllen - params.len);
        }
      });
      this.startFly();
    },
    formatTime: function formatTime(strtime) {
      strtime = Number(strtime) || 0;

      if (strtime < 60) {
        return strtime.toFixed(0) + '秒';
      } else if (strtime >= 60 && strtime < 3600) {
        var miao = Math.floor(strtime % 60);
        return Math.floor(strtime / 60) + '分钟' + (miao != 0 ? miao + '秒' : '');
      } else {
        strtime = Math.floor(strtime / 60); // 秒转分钟

        return Math.floor(strtime / 60) + '小时' + Math.floor(strtime % 60) + '分钟';
      }
    },
    startFly: function startFly() {
      // 启动漫游
      this.roamLine.start(); // 显示popup

      this.roamLine.openPopup();
    },
    // 显示实时坐标和时间
    showRealTimeInfo: function showRealTimeInfo(params, _alltime) {
      if (params == null) {
        return;
      }

      var val = Math.ceil(params.time * 100 / _alltime);

      if (val < 1) {
        val = 1;
      }

      if (val > 100) {
        val = 100;
      }

      this.roamLineData.percent = val;
      this.roamLineData.td_jd = params.lng;
      this.roamLineData.td_wd = params.lat;
      this.roamLineData.td_gd = mars3d.MeasureUtil.formatDistance(params.alt);
      this.roamLineData.td_times = this.formatTime(params.time);
      this.roamLineData.td_length = mars3d.MeasureUtil.formatDistance(params.len);

      if (params.hbgd) {
        this.roamLineData.td_dmhb = mars3d.MeasureUtil.formatDistance(params.hbgd);
      } else {
        this.roamLineData.td_dmhb = '未知';
      }

      if (params.ldgd) {
        this.roamLineData.td_ldgd = mars3d.MeasureUtil.formatDistance(params.ldgd);
      } else {
        this.roamLineData.td_ldgd = '未知';
      }
    }
  }
};